export default "__VITE_ASSET__BRC3DAkZ__"